import { render, staticRenderFns } from "./DynamicRegisterMultiSelect.vue?vue&type=template&id=6cd321c0"
import script from "./DynamicRegisterMultiSelect.vue?vue&type=script&lang=js"
export * from "./DynamicRegisterMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports